import { create } from "zustand";

const initialState = {
  ready: false,
  loading: true,
  errors: [],
};

const useAppStateStore = create((set) => ({
  ...initialState,
  setReady: (payload) => {
    const { ready } = payload;
    set({ ready });
  },
  setLoading: (payload) => {
    const { loading } = payload;
    set({ loading });
  },
  toggleLoading: () => {
    set((state) => ({ loading: !state.loading }));
  },
  addErrors: (payload) => {
    set((state) => ({ errors: [...state.errors, ...payload] }));
  },
  clearErrors: () => {
    set({ errors: [] });
  },
}));

export default useAppStateStore;
